'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_ImportRecipesPage$StepNumber$() {
  this.lr = null;
  this.nC = null;
  this.mD = false;
  this.dv = 0;
  this.al = null;
  this.nB = 0;
  this.jj = 0;
  this.oO = null;
  this.oP = false;
  this.oQ = null;
  this.oR = false;
  this.zs = null;
  this.SJ = null;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_Enumeration__I__(this, 0);
  $n_Lmealorama_pages_ImportRecipesPage$StepNumber$ = this;
  var name = (((this.al !== null) && this.al.l()) ? this.al.k() : "gather");
  this.zs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name);
  var name$1 = (((this.al !== null) && this.al.l()) ? this.al.k() : "editRecipe");
  this.SJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name$1);
}
export { $c_Lmealorama_pages_ImportRecipesPage$StepNumber$ as $c_Lmealorama_pages_ImportRecipesPage$StepNumber$ };
$p = $c_Lmealorama_pages_ImportRecipesPage$StepNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Enumeration();
$p.constructor = $c_Lmealorama_pages_ImportRecipesPage$StepNumber$;
/** @constructor */
function $h_Lmealorama_pages_ImportRecipesPage$StepNumber$() {
}
export { $h_Lmealorama_pages_ImportRecipesPage$StepNumber$ as $h_Lmealorama_pages_ImportRecipesPage$StepNumber$ };
$h_Lmealorama_pages_ImportRecipesPage$StepNumber$.prototype = $p;
var $d_Lmealorama_pages_ImportRecipesPage$StepNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_ImportRecipesPage$StepNumber$, "mealorama.pages.ImportRecipesPage$StepNumber$", ({
  L7: 1,
  aX: 1,
  a: 1
}));
export { $d_Lmealorama_pages_ImportRecipesPage$StepNumber$ as $d_Lmealorama_pages_ImportRecipesPage$StepNumber$ };
var $n_Lmealorama_pages_ImportRecipesPage$StepNumber$;
function $m_Lmealorama_pages_ImportRecipesPage$StepNumber$() {
  if ((!$n_Lmealorama_pages_ImportRecipesPage$StepNumber$)) {
    $n_Lmealorama_pages_ImportRecipesPage$StepNumber$ = new $c_Lmealorama_pages_ImportRecipesPage$StepNumber$();
  }
  return $n_Lmealorama_pages_ImportRecipesPage$StepNumber$;
}
export { $m_Lmealorama_pages_ImportRecipesPage$StepNumber$ as $m_Lmealorama_pages_ImportRecipesPage$StepNumber$ };
//# sourceMappingURL=mealorama.pages.-Import-Recipes-Page$-Step-Number$.js.map
